import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
import("lazysizes").then((lazySizes) => {
  lazySizes.init();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
